import { ShieldCheck, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CapabilitiesHero() {
  return <section data-section-id="262729" id="capabilities-hero" className="w-full py-10 md:py-16 lg:py-20 bg-[#0B1220] text-white flex flex-col items-center justify-center text-center px-4 md:px-6">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-3 md:gap-4 animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both">
        
        {}
        <div className="inline-flex items-center gap-2 text-sm font-bold tracking-widest text-[#0F62FE] font-mono uppercase">
          <ShieldCheck className="w-4 h-4" />
          <span>DETAILED CAPABILITY CATALOGUE</span>
        </div>

        {}
        <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold font-default text-white tracking-tighter leading-[1.1]">
          Explore Our Cybersecurity, Technology and Integration Capabilities
        </h1>

        {}
        <p className="text-lg md:text-xl text-white/80 font-default max-w-3xl leading-relaxed">
          FETC helps government and enterprise organizations assess requirements, design secure architectures, integrate enabling technologies and strengthen digital resilience through practical delivery-focused services.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
          <Button asChild size="lg" className="bg-[#0F62FE] text-white hover:bg-[#0043CE] border-none rounded-md px-8 transition-colors duration-200 shadow-md cursor-pointer">
            <Link to="/ContactUsPage">
              Request a Consultation
            </Link>
          </Button>
          
          <Button size="lg" onClick={() => document.getElementById("service-domains")?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        })} className="bg-[#0F62FE] text-white hover:bg-[#0043CE] border-none rounded-md px-6 transition-colors duration-200 shadow-md flex items-center gap-2 cursor-pointer">
            View Capability Domains
            <ChevronDown className="w-4 h-4 text-white" />
          </Button>
        </div>

      </div>
    </section>;
}